/**
 * `HTMLMediaElement.play()` returns a Promise that rejects with `AbortError` when
 * `pause()`, `load()`, or navigation interrupts playback before it starts.
 * @see https://goo.gl/LdLk22
 */
export function safePlayVideo(video: HTMLVideoElement): void {
  try {
    const pending = video.play();
    if (pending !== undefined) {
      void pending.catch((err: unknown) => {
        if (err instanceof DOMException && err.name === "AbortError") return;
        if (
          typeof err === "object" &&
          err !== null &&
          "name" in err &&
          (err as { name: string }).name === "AbortError"
        ) {
          return;
        }
      });
    }
  } catch (err: unknown) {
    if (err instanceof DOMException && err.name === "AbortError") return;
    throw err;
  }
}
